import purple from './purpleTheme';
import orange from './orangeTheme';
import pink from './pinkTheme';

export { purple, orange, pink };
export default pink;
